
export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-blue-900 to-blue-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/6214d334b00eb7faf97c61a8b8784857/89e3759e831ea9226f20f25512a960ed.png" 
                alt="MediMar Medical Market Logo" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-lg opacity-90 leading-relaxed">
              Your trusted HME provider specializing in CPAP & BiPAP machines, masks, and supplies in Sarasota, Florida.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-yellow-400">Contact Information</h4>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center bg-opacity-20">
                  <i className="ri-map-pin-fill text-yellow-400"></i>
                </div>
                <div>
                  <p className="font-medium">2079 Global Ct</p>
                  <p className="opacity-90">Sarasota, FL 34240</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-blue-400 rounded-full flex items-center justify-center bg-opacity-20">
                  <i className="ri-phone-fill text-blue-400"></i>
                </div>
                <a href="tel:941.286.4000" className="text-lg font-semibold hover:text-yellow-400 transition-colors">
                  941.286.4000
                </a>
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-yellow-400">Business Hours</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <i className="ri-time-fill text-green-400"></i>
                <div>
                  <p className="font-semibold">Monday - Friday</p>
                  <p className="opacity-90">10:00 AM - 4:00 PM</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-close-circle-fill text-red-400"></i>
                <div>
                  <p className="font-semibold">Saturday & Sunday</p>
                  <p className="opacity-90">Closed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-yellow-400">Our Specialties</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <i className="ri-lungs-fill text-blue-400"></i>
                <span>CPAP Machines</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-heart-pulse-fill text-blue-400"></i>
                <span>BiPAP Machines</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-shield-check-fill text-blue-400"></i>
                <span>CPAP Masks</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-tools-fill text-blue-400"></i>
                <span>CPAP Supplies</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white mt-12 pt-8 border-opacity-20 flex flex-col md:flex-row justify-between items-center">
          <p className="text-center md:text-left opacity-90">
            © 2025 MediMar Medical Market. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-yellow-400 hover:text-white transition-colors mt-4 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
